import { Border } from 'themes/interfaces';

export default {
  factor: 4,
  radius: 3,
  square: 0,
  circle: 30
} as Border;
